import React from "react";
import "../../css/pages/services.scss";
import servicesImage from "../../assets/services/services-img.png";
import physiotherapyImage from "../../assets/services/physiotherapy.png";
import occupationalTherapyImage from "../../assets/services/occupational-therapy.png";
import psychologicalCounselingImage from "../../assets/services/psychological-counseling.png";
import speechTherapyImage from "../../assets/services/speech-therapy.png";
import { Divider } from "@mui/material";

const ServiceCard = ({
  image,
  title,
  description,
}: {
  image: string;
  title: string;
  description: string;
}) => {
  return (
    <div className="serviceCard">
      <img src={image} alt={title} className="serviceImage" />
      <h2 className="serviceTitle">{title}</h2>
      <p className="serviceDescription">{description}</p>
    </div>
  );
};
const servicesData = [
  {
    title: "فیزیوتراپی",
    description: "ارائه خدمات فیزیوتراپی برای بهبود حرکتی و کاهش درد",
    image: physiotherapyImage,
  },
  {
    title: "کاردرمانی",
    description: "برنامه‌های کاردرمانی برای بهبود عملکرد روزمره",
    image: occupationalTherapyImage,
  },
  {
    title: "مشاوره روانشناسی",
    description: "خدمات مشاوره برای بهبود سلامت روان",
    image: psychologicalCounselingImage,
  },
  {
    title: "گفتاردرمانی",
    description: "درمان مشکلات گفتاری و زبانی",
    image: speechTherapyImage,
  },
];
function Services() {
  return (
    <div className="servicesWrapper">
      <div className="servicesHeader">
        <Divider>
          <h1 className="servicesTitle">خدمات</h1>
        </Divider>
      </div>
      <div className="servicesContainer">
        <div className="servicesImage">
          <img src={servicesImage} alt="Services" />
        </div>
        <div className="servicesContent">
          {servicesData.map((service, index) => (
            <ServiceCard
              key={index}
              image={service.image}
              title={service.title}
              description={service.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Services;
